// extracted by mini-css-extract-plugin
module.exports = {"container":"_2VOmsXmPdrqZCxwjQBsD9","wrapper":"_12A8yCJCSJVLzV0uVp0lyK"};